import Compliance from './Compliance.container';

export default Compliance;
